<template>
  <div class="list">
    <div class="item is-noBgColor">
      <div class="dod_item_view">
        <div class="D13_pc">
          <div class="D13_pc_modal" />
        </div>
      </div>
    </div>
    <div class="item is-noBgColor">
      <div class="dod_item_view">
        <div class="D13_mobile">
          <div class="D13_mobile_modal" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Day13',
  data: () => ({
  }),
  beforeDestroy() {
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
.D13_pc {
  @include FR_CENTER(xy);
  position: absolute;
  width: 300px;
  height: (300px / 1.75);
  background-color: red;
  border-radius: 5px;
}
.D13_mobile {
  @include FR_CENTER(xy);
  position: absolute;
  width: 150px;
  height: (150px * 1.75);
  background-color: red;
  border-radius: 10px;
}
.D13_pc_modal {
  @include FR_CENTER(xy);
  position: absolute;
  width: 300px * 0.5;
  height: (300px * 0.5 / 1.75);
  background-color: white;
  border-radius: 2px;
  box-shadow: 0 5px 10px rgba(#000000, 0.1);
}
.D13_mobile_modal {
  @include FR_CENTER(x);
  position: absolute;
  bottom: (150px * 0.1 / 2);
  width: (150px * 0.9);
  height: (150px * 0.9 / 1.618);
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 5px 10px rgba(#000000, 0.1);
}
</style>
